import React, { useRef, useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import approveSeal from "../images/approve.jpg";
import { message, Button, Select, Popconfirm, Empty, DatePicker } from 'antd';
import axios from "../../services/axios";
import moment from "moment";

const { Option } = Select;

const EditTransmittal = () => {
  const navigate = useNavigate();
  const formRef = useRef(null);
  const location = useLocation();
  const [isApproved, setIsApproved] = useState(false);
  const [errors, setErrors] = useState({});
  const [clientName, setClientName] = useState("");
  const [engineer, setEngineer] = useState("");
  const [contractor, setContractor] = useState("");
  const [assignedProjects, setAssignedProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const role = localStorage.getItem('role');
  const user = localStorage.getItem("user");
  let projectName = null;
  try {
    projectName = JSON.parse(localStorage.getItem('Project'));
  } catch (error) {
    console.error("Error parsing Project from localStorage:", error);
  }
  const [filters, setFilters] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [documentRows, setDocumentRows] = useState([]);

  const [transmitItems, setTransmitItems] = useState({
    Materials: { checked: false },
    Drawings: { checked: false },
    Schedules: { checked: false },
  });

  const [herewithItems, setHerewithItems] = useState({
    Correspondence: { checked: false },
    Reports: { checked: false },
    Documents: { checked: false },
  });

  const [submittedFor, setSubmittedFor] = useState({
    "For Approval": false,
    "For Your Information": false,
    "Response Required": false,
  });

  const [documentTypes, setDocumentTypes] = useState({
    Original: false,
    Copies: false,
    Contractor: false,
  });

  const [formData, setFormData] = useState({
    transmittalId: "",
    projectName: "",
    contractForm: "",
    date: new Date().toISOString().split("T")[0],
    contractor: "",
    engineer: "",
    client: "",
    revisionNo: "",
    from: "",
    to: "",
    documents: [],
    contractorText: "",
    engineerName: "",
    engineerDate: "",
    clientName: "",
    clientDate: "",
    clientText: "",
    approvedBy: "",
    approvedDate: "",
    responseDate: ""
  });

  const toggleCheckbox = (section, item, value = null, isCheckbox = true) => {
    const stateUpdaters = {
      transmit: setTransmitItems,
      herewith: setHerewithItems,
      submittedFor: setSubmittedFor,
      documentTypes: setDocumentTypes,
    };

    if (stateUpdaters[section]) {
      stateUpdaters[section]((prev) => {
        if (section === "submittedFor" || section === "documentTypes") {
          const newState = { ...prev, [item]: !prev[item] };
          setFormData((prevForm) => ({
            ...prevForm,
            [section]: newState,
          }));
          return newState;
        }

        const updatedItem = isCheckbox
          ? { ...prev[item], checked: !prev[item]?.checked }
          : { ...prev[item], text: value ?? "" };

        setFormData((prevForm) => ({
          ...prevForm,
          [section]: { ...prevForm[section], [item]: updatedItem },
        }));

        return { ...prev, [item]: updatedItem };
      });
    }
  };

  const handleRowChange = (id, field, value) => {
    setDocumentRows((prev) =>
      prev.map((row) =>
        row.id === id ? { ...row, [field]: value } : row
      )
    );
    setFormData((prev) => ({
      ...prev,
      documents: documentRows.map((row) => ({
        docRef: row.docRef,
        revision: row.revision,
        specNo: row.specNo,
        description: row.description,
      })),
    }));
  };

  const handleDocRefChange = (id, value) => {
    const selectedDoc = documents.find((doc) => doc.documentReference === value);
    const description = selectedDoc ? selectedDoc.documentDescription : '';

    setDocumentRows((prev) =>
      prev.map((row) =>
        row.id === id ? { ...row, docRef: value, description } : row
      )
    );
    setFormData((prev) => ({
      ...prev,
      documents: documentRows.map((row) => ({
        docRef: row.docRef,
        revision: row.revision,
        specNo: row.specNo,
        description: row.description,
      })),
    }));
  };

  const handleProjectChange = (e) => {
    const projectName = e.target.value;
    setSelectedProject(projectName);

    if (!assignedProjects.length) return;

    const project = assignedProjects.find((p) => p.projectName === projectName);

    if (project) {
      const client = project.client || project.clientName || "";
      const engineer = project.engineer || "";
      const contractor = project.contractor || "";

      setClientName(client);
      setEngineer(engineer);
      setContractor(contractor);

      setFormData((prev) => ({
        ...prev,
        client: client,
        engineer: engineer,
        contractor: contractor,
        contractForm: project.contractForm || "",
        projectName: projectName,
      }));
    } else {
      setClientName('');
      setEngineer('');
      setContractor('');
      setFormData((prev) => ({
        ...prev,
        client: '',
        engineer: '',
        contractor: '',
        contractForm: '',
        projectName: '',
      }));
    }
  };

  const handleApprove = () => {
    setIsApproved(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (value.trim()) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const finalData = {
      ...formData,
      projectName: selectedProject,
      client: clientName,
      engineer,
      contractor,
      date: formData.date || new Date().toISOString().split("T")[0],
      documents: documentRows.map((row) => ({
        docRef: row.docRef,
        revision: row.revision,
        specNo: row.specNo,
        description: row.description,
      })),
      transmitItems,
      herewithItems,
      submittedFor,
      documentTypes,
      responseDate: submittedFor["Response Required"] ? formData.responseDate : "",
    };

    try {
      const response = await axios.post(`/editTransmittal-form/${formData.transmittalId}`, finalData);
      if (response.status === 200 || response.status === 201) {
        message.success("Form updated successfully!");
        navigate('/home/viewTransmittal');
      }
    } catch (error) {
      message.error("Failed to update form");
    }
  };

  const fetchDocuments = async () => {
    try {
      setLoading(true);
      const res = await axios.post('get-all-documents', { role, user, projectName });
      if (res && res.data && res.data.documents) {
        setDocuments(res.data.documents);
        const reformattedArray = res.data.documents.map(({ projectName }) => ({ text: projectName, value: projectName }));
        const unique = [];
        reformattedArray.forEach((x) => unique.filter((a) => a.text === x.text && a.value === x.value).length > 0 ? null : unique.push(x));
        setFilters(unique);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
      } else if (err.response && err.response.status === 401) {
        message.error('User not authorized');
      } else {
        message.error('Something went wrong');
      }
    }
  };

  useEffect(() => {
    if (projectName) {
      fetchDocuments();
    }
  }, [projectName]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get("/get-projects", { params: { user } });
        const filteredProjects = projectName
          ? response.data.projects.filter((p) => p.projectName === projectName)
          : response.data.projects;

        setAssignedProjects(filteredProjects);

        if (filteredProjects.length === 1) {
          const project = filteredProjects[0];
          setSelectedProject(project.projectName);
          setClientName(project.client || project.clientName || "");
          setEngineer(project.engineer || "");
          setContractor(project.contractor || "");
          setFormData((prev) => ({
            ...prev,
            projectName: project.projectName,
            client: project.client || project.clientName || "",
            engineer: project.engineer || "",
            contractor: project.contractor || "",
            contractForm: project.contractForm || "",
          }));
        }
      } catch (error) {
        console.error("Error fetching assigned projects:", error);
      }
    };
    fetchProjects();
  }, [user, projectName]);

  useEffect(() => {
    if (location.state?.formData) {
      const data = location.state.formData;
      setFormData({
        ...data,
        documents: data.documents || [],
        date: data.date ? new Date(data.date).toISOString().split("T")[0] : new Date().toISOString().split("T")[0],
        engineerDate: data.engineerDate ? new Date(data.engineerDate).toISOString().split("T")[0] : "",
        clientDate: data.clientDate ? new Date(data.clientDate).toISOString().split("T")[0] : "",
        approvedDate: data.approvedDate ? new Date(data.approvedDate).toISOString().split("T")[0] : "",
        responseDate: data.responseDate ? new Date(data.responseDate).toISOString().split("T")[0] : "",
      });
      setDocumentRows(
        data.documents && data.documents.length > 0
          ? data.documents.map((doc, index) => ({
              id: index + 1,
              docRef: doc.docRef || '',
              revision: doc.revision || '',
              specNo: doc.specNo || '',
              description: doc.description || '',
            }))
          : [{ id: 1, docRef: '', revision: '', specNo: '', description: '' }]
      );
      setSelectedProject(data.projectName || "");
      setClientName(data.client || data.clientName || "");
      setEngineer(data.engineer || "");
      setContractor(data.contractor || "");
      setTransmitItems({
        Materials: data.Materials || { checked: false },
        Drawings: data.Drawings || { checked: false },
        Schedules: data.Schedules || { checked: false },
      });
      setHerewithItems({
        Correspondence: data.Correspondence || { checked: false },
        Reports: data.Reports || { checked: false },
        Documents: data.Documents || { checked: false },
      });
      setSubmittedFor({
        "For Approval": data.ForApproval || false,
        "For Your Information": data.ForYourInformation || false,
        "Response Required": data.ResponseRequired || false,
      });
      setDocumentTypes({
        Original: data.Original || false,
        Copies: data.Copies || false,
        Contractor: data.Contractor || false,
      });
      setIsApproved(!!data.approvedBy);
    }
  }, [location.state]);

  const handlePrint = () => {
    const originalContent = document.body.innerHTML;
    const printContent = formRef.current.cloneNode(true);

    const checkboxes = formRef.current.querySelectorAll("input[type='checkbox']");
    const clonedCheckboxes = printContent.querySelectorAll("input[type='checkbox']");

    checkboxes.forEach((checkbox, index) => {
      if (checkbox.checked) {
        clonedCheckboxes[index].setAttribute("checked", "checked");
      }
    });

    const style = `
      <style>
        @media print {
          @page {
            size: A4;
            margin: 0;
          }
          html, body {
            margin: 0;
            padding: 0;
            width: 100%;
            height: 100%;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          .print-content {
            width: 100%;
            max-height: 100vh;
            overflow: hidden;
            page-break-inside: avoid;
            transform: scale(0.95);
            transform-origin: top;
            padding-top: 15mm;
          }
          button, .no-print {
            display: none !important;
          }
        }
      </style>
    `;

    const printWrapper = document.createElement("div");
    printWrapper.className = "print-content";
    printWrapper.appendChild(printContent);

    document.body.innerHTML = style + printWrapper.outerHTML;

    window.print();

    setTimeout(() => {
      document.body.innerHTML = originalContent;
      window.location.reload();
    }, 100);
  };

  return (
    <div className="relative flex-1 bg-white p-5 overflow-y-auto ml-5 mr-2 min-h-screen">
      {!projectName ? (
        <Empty description="No Project Selected. Please select a project." className="text-center mt-4" />
      ) : (
        <>
          <Button
            type="default"
            className="mb-4"
            onClick={() => navigate('/home/viewTransmittal')}
          >
            Back
          </Button>

          <form ref={formRef}>
            <div className="flex justify-between items-center mb-2 gap-2">
              <div className="flex gap-2 flex-1">
                <div className="w-1/5 h-16 flex items-center justify-center p-1 border rounded text-sm">{clientName}</div>
                <div className="w-1/5 h-16 flex items-center justify-center p-1 border rounded text-sm">{contractor}</div>
                <div className="w-1/5 h-16 flex items-center justify-center p-1 border rounded text-sm">{engineer}</div>
                <div className="w-2/5 h-16 flex items-center justify-center p-1 border rounded font-bold text-lg">Document Transmittal Sheet</div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2 text-xs mb-2">
              <div className="flex items-center">
                <label className="w-20 font-semibold">Project:</label>
                {assignedProjects.length === 1 ? (
                  <input
                    type="text"
                    className="flex-1 border p-1 h-6"
                    name="projectName"
                    value={selectedProject}
                    disabled
                  />
                ) : (
                  <select
                    className="flex-1 border p-1 h-6"
                    name="projectName"
                    value={selectedProject}
                    onChange={handleProjectChange}
                  >
                    <option value="">Select Project</option>
                    {assignedProjects.map((proj) => (
                      <option key={proj.projectName} value={proj.projectName}>
                        {proj.projectName}
                      </option>
                    ))}
                  </select>
                )}
              </div>
              {formData.transmittalId ? (
                <div className="flex items-center">
                  <label className="w-20 font-semibold">Transmittal ID:</label>
                  <span className="flex-1 border p-1 h-6 bg-gray-200">{formData.transmittalId}</span>
                </div>
              ) : (
                <p>Loading Transmittal ID...</p>
              )}
              <div className="flex items-center">
                <label className="w-20 font-semibold">Contract No:</label>
                <input
                  type="text"
                  className="flex-1 border p-1 h-6"
                  name="contractForm"
                  value={formData.contractForm}
                  onChange={handleInputChange}
                />
              </div>
              <div className="flex items-center">
                <label className="w-20 font-semibold">Date:</label>
                <input
                  type="date"
                  className="flex-1 border p-1 h-6"
                  value={formData.date}
                  onChange={handleInputChange}
                  name="date"
                />
              </div>
              <div className="flex items-center">
                <label className="w-20 font-semibold">Contractor:</label>
                <input
                  type="text"
                  className="flex-1 border p-1 h-6"
                  name="contractor"
                  value={formData.contractor}
                  onChange={handleInputChange}
                />
              </div>
              <div className="flex items-center">
                <label className="w-20 font-semibold">Revision No:</label>
                <input
                  type="text"
                  className="flex-1 border p-1 h-6"
                  name="revisionNo"
                  value={formData.revisionNo}
                  onChange={handleInputChange}
                />
              </div>
              <div className="flex items-center">
                <label className="w-20 font-semibold">From:</label>
                <input
                  type="text"
                  className="flex-1 border p-1 h-6"
                  name="from"
                  value={formData.from}
                  onChange={handleInputChange}
                />
              </div>
              <div className="flex items-center">
                <label className="w-20 font-semibold">To:</label>
                <input
                  type="text"
                  className="flex-1 border p-1 h-6"
                  name="to"
                  value={formData.to}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="border p-4 mb-2 text-xs">
              <div className="flex gap-4">
                <div className="w-2/4">
                  <p><strong>We transmit herewith:</strong></p>
                  <div className="border p-2 flex justify-between">
                    <div className="w-1/2 pr-2">
                      <div className="flex items-center mb-2">
                        <input
                          type="checkbox"
                          className="mr-1"
                          checked={transmitItems.Materials?.checked || false}
                          onChange={() => toggleCheckbox("transmit", "Materials")}
                        />
                        <span>Materials</span>
                      </div>
                      <div className="flex items-center mb-2">
                        <input
                          type="checkbox"
                          className="mr-1"
                          checked={transmitItems.Drawings?.checked || false}
                          onChange={() => toggleCheckbox("transmit", "Drawings")}
                        />
                        <span>Drawings</span>
                      </div>
                      <div className="flex items-center mb-2">
                        <input
                          type="checkbox"
                          className="mr-1"
                          checked={transmitItems.Schedules?.checked || false}
                          onChange={() => toggleCheckbox("transmit", "Schedules")}
                        />
                        <span>Schedules</span>
                      </div>
                    </div>
                    <div className="w-1/2 pl-2">
                      <div className="flex items-center mb-2">
                        <input
                          type="checkbox"
                          className="mr-1"
                          checked={herewithItems.Correspondence?.checked || false}
                          onChange={() => toggleCheckbox("herewith", "Correspondence")}
                        />
                        <span>Correspondence</span>
                      </div>
                      <div className="flex items-center mb-2">
                        <input
                          type="checkbox"
                          className="mr-1"
                          checked={herewithItems.Reports?.checked || false}
                          onChange={() => toggleCheckbox("herewith", "Reports")}
                        />
                        <span>Reports</span>
                      </div>
                      <div className="flex items-center mb-2">
                        <input
                          type="checkbox"
                          className="mr-1"
                          checked={herewithItems.Documents?.checked || false}
                          onChange={() => toggleCheckbox("herewith", "Documents")}
                        />
                        <span>Documents</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-1/4">
                  <div className="font-semibold mb-1">The following items:</div>
                  <div className="border p-1 text-xs">
                    <div className="font-semibold text-gray-500">Action Codes:</div>
                    <div>A: Approved</div>
                    <div>B: Approved with Comments</div>
                    <div>C: Revise & Resubmit</div>
                    <div>D: Rejected</div>
                  </div>
                </div>
              </div>
            </div>

            <table className="w-full border text-xs mb-2 table-fixed">
              <thead className="bg-gray-100">
                <tr>
                  <th className="border p-1 w-[5%]">SL.NO</th>
                  <th className="border p-1 w-[40%]">Doc.Reference</th>
                  <th className="border p-1 w-[10%]">Revision</th>
                  {/* <th className="border p-1">Specs/IFC Drg.NO</th> */}
                  <th className="border p-1 w-[45%]">Description</th>
                </tr>
              </thead>
              <tbody>
                {documentRows.length > 0 ? (
                  documentRows.map((row) => (
                    <tr key={row.id}>
                      <td className="border p-1 text-center w-[5%]">{row.id}</td>
                      <td className="border p-1 w-[40%]">
                        <Select
                          className="w-full h-5 text-xs"
                          value={row.docRef || undefined}
                          onChange={(value) => handleDocRefChange(row.id, value)}
                          placeholder="Select Document Reference"
                          loading={loading}
                        >
                          {documents.map((doc) => (
                            <Option key={doc.documentReference} value={doc.documentReference}>
                              {doc.documentReference}
                            </Option>
                          ))}
                        </Select>
                      </td>
                      {["revision"
                      // , "specNo"
                        ].map((field) => (
                        <td className="border p-1 w-[10%]" key={field}>
                          <input
                            type="text"
                            className="w-full h-5 text-xs"
                            value={row[field] || ""}
                            onChange={(e) => handleRowChange(row.id, field, e.target.value)}
                          />
                        </td>
                      ))}
                      <td className="border p-1 w-[45%]">
                        <input
                          type="text"
                          className="w-full h-5 text-xs"
                          value={row.description || ""}
                          disabled
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="border p-1 text-center">
                      No documents selected
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <div className="text-xs mb-2">
              <div className="font-semibold mb-1">Submitted For:</div>
              <div className="grid grid-cols-4 gap-1">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    className="mr-1"
                    checked={submittedFor["For Approval"] || false}
                    onChange={() => toggleCheckbox("submittedFor", "For Approval")}
                  />
                  <span>For Approval</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    className="mr-1"
                    checked={submittedFor["For Your Information"] || false}
                    onChange={() => toggleCheckbox("submittedFor", "For Your Information")}
                  />
                  <span>For Your Information</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    className="mr-1"
                    checked={submittedFor["Response Required"] || false}
                    onChange={() => toggleCheckbox("submittedFor", "Response Required")}
                  />
                  <span>Response Required</span>
                </label>
                {submittedFor["Response Required"] && (
                  <div className="flex items-center">
                    <label className="mr-2 font-semibold">Response Date:</label>
                    <DatePicker
                      className="w-32 h-6 text-xs"
                      value={formData.responseDate ? moment(formData.responseDate) : null}
                      onChange={(date, dateString) =>
                        setFormData((prev) => ({ ...prev, responseDate: dateString }))
                      }
                      format="YYYY-MM-DD"
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="space-y-2 text-xs">
              <div className="border p-2">
                <div className="font-semibold mb-1">Contractor remarks</div>
                <textarea
                  className="w-full border h-12 mb-1 text-xs p-1"
                  value={formData.contractorText}
                  onChange={(e) => setFormData((prev) => ({ ...prev, contractorText: e.target.value }))}
                ></textarea>
              </div>

              <div className="border p-2">
                <div className="font-semibold mb-1">Engineer's remarks</div>
                <textarea
                  className="w-full border h-12 mb-1 text-xs p-1"
                  value={formData.engineerText}
                  onChange={(e) => setFormData((prev) => ({ ...prev, engineerText: e.target.value }))}
                ></textarea>
                <div className="grid grid-cols-3 gap-2">
                  <div>
                    <label className="block">Engineer Name:</label>
                    <input
                      type="text"
                      className="border w-full h-6"
                      value={formData.engineerName}
                      onChange={(e) => setFormData((prev) => ({ ...prev, engineerName: e.target.value }))}
                    />
                  </div>
                  <div>
                    <label className="block">Engineer Signature:</label>
                    <canvas id="signaturePad2" className="border rounded w-full h-6 bg-white"></canvas>
                  </div>
                  <div>
                    <label className="block">Engineer Date:</label>
                    <input
                      type="date"
                      className="border w-full h-6"
                      value={formData.engineerDate}
                      onChange={(e) => setFormData((prev) => ({ ...prev, engineerDate: e.target.value }))}
                    />
                  </div>
                </div>
              </div>

              <div className="border p-2">
                <div className="font-semibold mb-1">Client's remarks</div>
                <textarea
                  className="w-full border h-12 mb-1 text-xs p-1"
                  value={formData.clientText}
                  onChange={(e) => setFormData((prev) => ({ ...prev, clientText: e.target.value }))}
                ></textarea>
                <div className="grid grid-cols-3 gap-2">
                  <div>
                    <label className="block">Client Name:</label>
                    <input
                      type="text"
                      className="border w-full h-6"
                      value={formData.clientName}
                      onChange={(e) => setFormData((prev) => ({ ...prev, clientName: e.target.value }))}
                    />
                  </div>
                  <div>
                    <label className="block">Client Signature:</label>
                    <canvas id="signaturePad3" className="border rounded w-full h-6 bg-white"></canvas>
                  </div>
                  <div>
                    <label className="block">Client Date:</label>
                    <input
                      type="date"
                      className="border w-6 h-6"
                      value={formData.clientDate}
                      onChange={(e) => setFormData((prev) => ({ ...prev, clientDate: e.target.value }))}
                    />
                  </div>
                </div>
              </div>

              <div className="border p-2 text-center">
                <h5 className="text-sm font-semibold">
                  No comments or signature on this form relieve the contractor from any obligations under the contract
                </h5>
              </div>

              <div className="border p-2 mt-4 flex">
                <div className="w-2/5 flex flex-col space-y-2">
                  <label className="flex items-center text-xs">
                    <input
                      type="checkbox"
                      className="mr-2"
                      checked={documentTypes.Original || false}
                      onChange={() => toggleCheckbox("documentTypes", "Original")}
                    />
                    Original
                  </label>
                  <label className="flex items-center text-xs">
                    <input
                      type="checkbox"
                      className="mr-2"
                      checked={documentTypes.Copies || false}
                      onChange={() => toggleCheckbox("documentTypes", "Copies")}
                    />
                    Copies
                  </label>
                  <label className="flex items-center text-xs">
                    <input
                      type="checkbox"
                      className="mr-2"
                      checked={documentTypes.Contractor || false}
                      onChange={() => toggleCheckbox("documentTypes", "Contractor")}
                    />
                    Contractor
                  </label>
                </div>
                <div className="w-3/5 flex items-center" style={{ marginLeft: '10.5rem' }}>
                  {role.includes('Document Controller') && !isApproved && (
                    <button onClick={handleApprove} className="bg-blue-500 text-white px-4 py-2">
                      Approve
                    </button>
                  )}
                  {(isApproved || role.includes('Super User')) && (
                    <div className="flex items-center space-x-3">
                      <div className="flex flex-col">
                        <label className="text-xs font-semibold">Approved By:</label>
                        <input
                          type="text"
                          className="border w-44 h-10 p-2 text-sm"
                          value={formData.approvedBy}
                          onChange={(e) =>
                            setFormData((prev) => ({ ...prev, approvedBy: e.target.value }))
                          }
                          disabled={!role.includes('Document Controller')}
                        />
                        <label className="text-xs font-semibold mt-1">Date:</label>
                        <input
                          type="date"
                          className="border w-44 h-10 p-2 text-sm"
                          value={formData.approvedDate}
                          onChange={(e) =>
                            setFormData((prev) => ({ ...prev, approvedDate: e.target.value }))
                          }
                          disabled={!role.includes('Document Controller')}
                        />
                      </div>
                      <img src={approveSeal} alt="Approved Seal" className="w-32 h-32 opacity-90" />
                    </div>
                  )}
                </div>
              </div>
            </div>

            {((role.includes('Super User') || (role.includes('Document Controller') && isApproved))) && (
              <div className="flex justify-center gap-4 mt-2">
                <Button onClick={handlePrint} className="bg-blue-500 text-white px-3 py-1 text-sm rounded">
                  Print Form
                </Button>
                <Popconfirm
                  title="Are you sure you want to save this transmittal form?"
                  onConfirm={handleSubmit}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    type="button"
                    className="bg-green-500 text-white px-3 py-1 text-sm rounded"
                    loading={loading}
                  >
                    Save
                  </Button>
                </Popconfirm>
              </div>
            )}
          </form>
        </>
      )}
    </div>
  );
};

export default EditTransmittal;